
export type ComposerPayloadMediaItem = {
  id?: string;
  type?: string;
  url?: string;
};
